import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { ModalContainerComponent } from "../modal-container/modal-container.component";
import { SafeUrlPipe } from "../../../../util/pipes/safe-url.pipe";
import Player from '@vimeo/player';
import { SpinnerService } from "../../../../core/service/spinner.service";
import { NOTIFICATIONS, NotificationsService } from "../../../../core/service/notifications.service";

@Component({
  selector: 'app-video-player',
  imports: [
    ModalContainerComponent,
    SafeUrlPipe,
  ],
  templateUrl: './video-player.component.html',
  styleUrl: './video-player.component.scss',
})
export class VideoPlayerComponent implements AfterViewInit {
  private spinnerService = inject(SpinnerService);
  private notificationsService = inject(NotificationsService);
  private player: Player;

  @Input({ required: true }) vimeoUrl: string;
  @Output() closeButtonClickedEmitter = new EventEmitter<void>();

  @ViewChild('videoPlayer', { static: false }) videoPlayer!: ElementRef<HTMLElement>;
  @ViewChild('spinnerDiv') spinnerDiv: ElementRef;

  videoReady = false;

  ngAfterViewInit(): void {
    this.spinnerService.startLoadingForComponent(this.spinnerDiv);
    this.player = new Player(this.videoPlayer.nativeElement);
    this.player.ready()
      .catch((err) => {
        this.spinnerService.finishLoadingForComponent(this.spinnerDiv);
        this.notificationsService.error({
          title: NOTIFICATIONS.VIDEO_ERROR.title,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access
          message: err.message ?? NOTIFICATIONS.VIDEO_ERROR.message,
        });
        this.closeButtonClickedEmitter.emit();
      });
    this.player.on('loaded', () => {
      this.videoReady = true;
      this.spinnerService.finishLoadingForComponent(this.spinnerDiv);
    });
  }
}
